/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatBottomSheetService } from 'src/app/services/mat-bottom-sheet.service';
import { PassportLoginComponent } from '../login/login.component';
import { BottomSheetConfig } from 'src/app/interfaces/mat.interface';
import { IonicModule, ModalController } from '@ionic/angular';
import { PassportPopUpComponent } from '../popup/popup.component';
import { PassportIconComponent } from 'src/app/shared/icons/passport.component';
import { AuthService } from 'src/app/auth/services';
import { CookieService } from 'ngx-cookie-service';
import { GamificationService } from '../../services';
import { BottomSheet, PopUp } from '../../interfaces';
import { AddBadgeComponent } from '../../components';

@Component({
  selector: "app-passport-fab",
  imports: [
    CommonModule,
    TranslateModule,
    IonicModule,
    PassportIconComponent
  ],  
  standalone: true,
  templateUrl: "./fab-button.component.html",
  styleUrls: ["./fab-button.component.scss"],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None
})

export class PassportFabButtonComponent {
    private modalController: ModalController = inject(ModalController);
    private matBottomSheetService: MatBottomSheetService = inject(MatBottomSheetService);
    private cookieService: CookieService = inject(CookieService);
    private authService: AuthService= inject(AuthService);
    private _gamificationService = inject(GamificationService);

    public passportEnabled = computed(() => this._gamificationService.passportsEnabled());
    private popUp = computed<PopUp>(() => this._gamificationService.passportPopup());
    public buttomSheet = computed<BottomSheet>(() => this._gamificationService.passportBottomSheet());
    private modal: any;

    ngAfterViewInit(){
      this.openPopUp();
    }

    openPopUp(){
      const cookie =  this.cookieService.get('passport-viewed');
      if (cookie === 'true' || this.authService.user() || !this.popUp())
        return;

      setTimeout(() => { 
        this.showPassportPopUp() 
      }, 5000);
    }

    public handleClick(){
      if (!this.authService.user()){
        this.openPassportLoginBottomSheet();
        return;
      }
      // this.openMyStampsBottomSheet();
      this.openPassportAddStampBottomSheet();
    }

    private async openPassportLoginBottomSheet() {
      const bottomSheetConfig: BottomSheetConfig<PassportLoginComponent, any> = {
          component: PassportLoginComponent,
          data: this.buttomSheet(),
          panelClass: 'passport-login-bottom-sheet'
      };
      
      await this.matBottomSheetService.openMatBottomSheet(bottomSheetConfig);
    }

    private async openPassportAddStampBottomSheet() {
      const bottomSheetConfig: BottomSheetConfig<AddBadgeComponent, any> = {
          component: AddBadgeComponent,
          panelClass: 'passport-add-stamp-bottom-sheet'
      };
      
      await this.matBottomSheetService.openMatBottomSheet(bottomSheetConfig);
    }

    // TODO: REMOVE ??? NO SE USA
    //public async openMyStampsBottomSheet() {
    //  const bottomSheetConfig: BottomSheetConfig<PassportMyStampsComponent, any> = {
    //      component: PassportMyStampsComponent,
    //      data: {
    //        idRef: 1
    //      }
    //  };
      
    //  await this.matBottomSheetService.openMatBottomSheet(bottomSheetConfig);
    //}

    async showPassportPopUp(){
      this.modal = await this.modalController.create({
          component: PassportPopUpComponent,
          cssClass: ['passport-modal', 'ion-disable-focus-trap'],
          componentProps: {
            popUp: this.popUp()
          }
      });
      await this.modal.present();
    }
  
}
